module.exports = __webpack_public_path__ + "img/icon-customer-lots.bc89ef23.svg";